<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Regulier tarief dividendbelasting in Nederland
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Het reguliere tarief van de dividendbelasting in Nederland bedraagt 15%. Dit betekent dat als een
                Nederlands bedrijf dividend uitkeert aan een aandeelhouder, het bedrijf doorgaans 15% van het
                brutodividend als belasting inhoudt en afdraagt aan de Belastingdienst.

                <div class="space20"></div>
                Er zijn echter uitzonderingen en belastingverdragen die invloed kunnen hebben op dit tarief, vooral als
                de aandeelhouder een buitenlandse partij is. In dat geval kan het tarief mogelijk lager zijn op basis
                van internationale belastingverdragen tussen Nederland en het land van de aandeelhouder. Bijvoorbeeld,
                als er een belastingverdrag is, kan het tarief vaak worden verlaagd tot 0% of 5%, afhankelijk van de
                specifieke afspraken.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2"
                    aria-expanded="false" aria-controls="collapse2">
                Aanmerkelijk belang in de aangifte inkomstenbelasting (box 2)
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Box 2 in de inkomstenbelasting is bedoeld voor inkomsten uit aanmerkelijk belang (AB). Je hebt een
                aanmerkelijk belang als je minimaal 5% van de aandelen (of stemrechten) hebt in een bv/nv (direct of
                indirect). Dit geldt ook bij BV’s via een holdingstructuur of samen met je fiscale partner.
                <div class="space20"></div>

                Inkomsten die je moet opgeven in box 2 zijn dividenduitkeringen en winst bij verkoop van aandelen. De
                door de BV ingehouden dividendbelasting mag je verrekenen als voorheffing op de verschuldigde box
                2-belasting.
            </div>
        </div>
    </div>
</div>
